<template>
  <div class="home_banner_module">
    <el-carousel :interval="5000" arrow="always" :height="bannerHight+'px'">
      <el-carousel-item v-for="(item,index) in homeBannerList" :key="index">
        <div @click="bannerAction(item.bannerUrl)">
          <img :src="item.bannerImg" :alt="item.bannerName" height="600" width="100%">
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import { bannerList } from '@/api/frontApi/frontHome';
export default {
  data() {
    return {
      srcArr: [
        {
          path: '../../../../static/img/banner/banner-1.jpg',
          url: 'http://zhny.chiaic.com'
        },
        {
          path: '../../../../static/img/banner/banner-1.png',
          url: 'http://zhny.chiaic.com'
        },
        {
          path: '../../../../static/img/banner/banner-2.jpg',
          url: 'http://yg.chiaic.com'
        }
      ],
      bannerHight: 600,
      homeBannerList: []
    };
  },
  created() {
    this.initBanner();
  },
  methods: {
    bannerAction(urlData) {
      if (urlData) window.open('http://' + urlData);
    },
    initBanner() {
      bannerList().then(res => {
        this.homeBannerList = res.data;
      });
    }
  }
};
</script>
<style scoped>
.home_banner_module {
  width: 100%;
  height: 100%;
  position: relative;
  top: 0;
  left: 0;
  z-index: 6;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/home/banner.vue